import React from 'react';
import PROJECTS from '../data/projects';

const Project = props => {

        const {title,image,description,link,tags} = props.project;

        return(
            <div className="col-sm-4" align="center" >
                <div className="project-box">
                    <h3>{title}</h3>
                    <img src={image} alt={title} className="img-rounded" />
                    <p>{description}</p>
                    <p className="font-weight-bold">Tags: {tags}</p>
                    <a href={link}>Github Link</a>
                </div>
            </div>
        )
}

const Projects = () => (
    <div>
        <h1 align="center" className="font-weight-bold">Projects</h1>
        <br/>
        <div className="row">
            {
                PROJECTS.map(PROJECT => {
                    return(
                        <Project  key = {PROJECT.id} project={PROJECT} />
                    );
                })
            }
        </div>
    </div>
)

export default Projects;